module.exports = __webpack_public_path__ + "media/images/logotipo-a632bb99635a5aad41b2e401cb1412f9.png";